export default "__VITE_ASSET__DSo$_JZ$__"